var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-app-bar',{attrs:{"color":"blue-grey lighten-3","dark":"","app":"","clipped-left":""}},[_c('app-bar-links')],1),_c('v-main',[_c('router-view')],1),_c('v-footer',{attrs:{"padless":""}},[_c('footer-affiliations')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }